/* CreateQuestionComponent.js */

"use strict";
//const EventEmitter = require("events").EventEmitter;
//const Renderer = require("./CreateQuestionRenderer");
const BaseCreateComponent = require("../../../../lib/actions/components/create/BaseCreateComponent");

class CreateQuestionComponent extends BaseCreateComponent {
    constructor(logger, title, message) {
        super(logger, title || "Create Policy - Please specify policy name", message, "Enter Policy Name");
    }
}

module.exports = CreateQuestionComponent;
